import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Simple header following theme */}
      <header className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 group"
        >
          <div className="w-9 h-9 bg-[#17265a] text-white flex items-center justify-center text-sm font-semibold">
            AW
          </div>
          <span className="text-lg font-bold tracking-tight text-[#17265a] group-hover:opacity-80">
            Aiserwave
          </span>
        </button>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-xl w-full text-center space-y-6">
          <p className="text-xs font-semibold tracking-[0.35em] text-[#17265a] uppercase">
            404
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900">
            This page doesn&apos;t exist yet.
          </h1>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg">
            You might have followed a broken link or typed an address that
            doesn&apos;t exist. Let&apos;s get you back to where the events are
            actually happening.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3 pt-2">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="inline-flex items-center justify-center gap-2 px-4 py-2.5 border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>Go back</span>
            </button>
            <button
              type="button"
              onClick={() => navigate("/")}
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-[#17265a] text-white text-sm font-semibold hover:bg-[#0f1a3f] shadow-sm hover:shadow-md transition-colors"
            >
              <Home className="w-4 h-4" />
              <span>Back to home</span>
            </button>
          </div>
        </div>
      </main>

      <footer className="px-6 py-4 border-t border-gray-100 text-center text-xs text-gray-400">
        © {new Date().getFullYear()} Aiserwave. All rights reserved.
      </footer>
    </div>
  );
};

export default NotFound;
